import { render, staticRenderFns } from "./Checkout2Summary.vue?vue&type=template&id=2288a845&scoped=true&"
import script from "./Checkout2Summary.vue?vue&type=script&lang=js&"
export * from "./Checkout2Summary.vue?vue&type=script&lang=js&"
import style0 from "./Checkout2Summary.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Checkout2Summary.vue?vue&type=style&index=1&id=2288a845&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2288a845",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
